import { render, staticRenderFns } from "./agrocolor.vue?vue&type=template&id=7af42310"
import script from "./agrocolor.vue?vue&type=script&lang=js"
export * from "./agrocolor.vue?vue&type=script&lang=js"
import style0 from "./agrocolor.vue?vue&type=style&index=0&id=7af42310&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports